export const ADD_VIRTUAL_CARD_START = 'ADD_VIRTUAL_CARD_START';
export const ADD_VIRTUAL_CARD_SUCCESS = 'ADD_VIRTUAL_CARD_SUCCESS';
export const ADD_VIRTUAL_CARD_ERROR = 'ADD_VIRTUAL_CARD_ERROR';
export const ADD_VIRTUAL_CARD_END = 'ADD_VIRTUAL_CARD_END';
export const CLEAR_ADD_VIRTUAL_CARD_STORE =
  'CLEAR_ADD_VIRTUAL_CARD_STORE';
